/**
 * @generated SignedSource<<b057c3b69fc8ee4ccda6c8e941e24ece>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MicrophoneRecording_createClientSideRecordingMutation$variables = {
  noteId?: string | null;
};
export type MicrophoneRecording_createClientSideRecordingMutation$data = {
  readonly startMicrophoneRecording: {
    readonly meetingRecording: {
      readonly id: string;
    };
  } | null;
};
export type MicrophoneRecording_createClientSideRecordingMutation = {
  response: MicrophoneRecording_createClientSideRecordingMutation$data;
  variables: MicrophoneRecording_createClientSideRecordingMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "noteId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "noteId",
        "variableName": "noteId"
      }
    ],
    "concreteType": "StartMicrophoneRecording",
    "kind": "LinkedField",
    "name": "startMicrophoneRecording",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MeetingRecording",
        "kind": "LinkedField",
        "name": "meetingRecording",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MicrophoneRecording_createClientSideRecordingMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MicrophoneRecording_createClientSideRecordingMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "12d87543518ab3c86accf37184cad957",
    "id": null,
    "metadata": {},
    "name": "MicrophoneRecording_createClientSideRecordingMutation",
    "operationKind": "mutation",
    "text": "mutation MicrophoneRecording_createClientSideRecordingMutation(\n  $noteId: ID\n) {\n  startMicrophoneRecording(noteId: $noteId) {\n    meetingRecording {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "55a3d0d5079a4bf4c7724e624b47bf04";

export default node;
